// extracted by mini-css-extract-plugin
export var label = "_dc-2";
export var slideContainer = "_dc-0";
export var slider = "_dc-1";